export default "//cloud.imgsmail.ru/cloud.mail.ru/188971/img/build/ask-phone-popup/must-phone.png";